module.exports = __webpack_public_path__ + "img/settings-selected.39da0beb.svg";